<div class="container">
  <div class="profile-page">
    <div class="profile-page__header">
      <div id="map" class="map" [class.title-placeholder]="loading"></div>
      <div class="body">
        <div class="img-with-chart" [class.active]="chartPopup">
          <img loading="lazy" class="profile-img" (click)="chartPopup = !chartPopup" [class.title-placeholder]="loading"
            src="{{ local.checkImageProfile(profileInfo) }}" alt="" />
          <div class="my-chart">
            <canvas baseChart [data]="radarChartData" [options]="radarChartOptions" [type]="radarChartType"> </canvas>
          </div>
        </div>
        <div class="name">
          {{ profileInfo.profileCharacterName }}
          <div>
            <span class="badge" *ngFor="let item of profileInfo?.certified">
              {{ item }}
            </span>
          </div>
        </div>
        <div class="meta">
          <span class="item"> <i class="fa-regular fa-clock"></i>Since {{ profileInfo.created }} </span>
          <span class="item"> <i class="fa-regular fa-square-plus"></i>{{ profileInfo?.appUserSupports?.length }}
            Support
          </span>
          <span class="item" *ngIf="profileInfo?.region"> <i class="fa-solid fa-earth-asia"></i>{{
            profileInfo.region.split("|")[1] }} </span>
        </div>
        <div class="about">
          {{ profileInfo.shortDescription }}
        </div>
        <!-- <div class="back" (click)="goBack()">
          <i class="fa fa-caret-left back-btn"></i>
          Back
        </div> -->
        <div class="bottom">
          <div class="certificates">
            @if(profileInfo?.certificates?.length){
            <div class="certificates__title">Badge</div>
            <ng-container *ngFor="let role of profileInfo?.certificates">
              <img loading="lazy" src="{{ certificateImgUrl }}{{ role.role }}.png" alt="" />
            </ng-container>
            }
          </div>
          <div class="right">
            <button class="button-2 mr-2" routerLink="/advanced-settings">
              <i class="fas fa-gear"></i>
            </button>
            <button class="button-2 mr-2" [class.active]="profileInfo.isSupport" (click)="handleSupportSeller()"><i
                class="fa-solid fa-plus"></i> Friend</button>
            <span class="icon-list" aria-hidden="true" id="profileMenu" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <i class="fa-solid fa-ellipsis-v"></i>
            </span>
            <div class="dropdown-menu" aria-labelledby="profileMenu">
              <a class="dropdown-item" (click)="setProfileToDefault()"><i class="fa-solid fa-user-check"></i> Set
                Profile to Default</a>
              <a class="dropdown-item" (click)="setProfileToAvatar()"><i class="fa-solid fa-user-check"></i> Set Profile
                to Avatar</a>
              <!-- <a class="dropdown-item" *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_MUTE')" (click)="muteProfile()"><i class="fa-solid fa-volume-mute"></i> {{ profileInfo.isMuted ? "Unmute" : "Mute" }}</a>
              <a class="dropdown-item" *ngIf="roleService?.roles?.users?.includes('COMMUNITY_PROFILE_BLOCK')" (click)="blockProfile()"><i class="fa-solid fa-ban"></i> {{ profileInfo.isBlocked ? "Unblock" : "Block" }}</a> -->
              <a class="dropdown-item" (click)="shareMyProfile(SharePopup)"><i class="fa-solid fa fa-share-alt"></i>
                Share</a>
              <a class="dropdown-item" (click)="handleChatNow()"><i class="fa-solid fa-comment-dots"></i> Chat Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="profile-page__product">
      <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
        <div allTab>
          <div class="search">
            <input type="text" (keyup)="filterProduct($event)" placeholder="Search for name or description..." />
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="text-center border-0 p-4" *ngIf="selMenu == 0 && productAllProductListFavorites.length < 1">
            <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
            <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
            <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try
              adjusting
              your filters or browse our categories.</p>
          </div>

          <div class="text-center border-0 p-4" *ngIf="selMenu != 0 && productAllProductListFiltered.length < 1">
            <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
            <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
            <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try
              adjusting
              your filters or browse our categories.</p>
          </div>
          <div class="products">
            @if(!loadingProduct){

            @if(selMenu == 0) {

            <ng-container *ngFor="let i of productAllProductListFavorites">
              <common-product-card-view *ngIf="i.isFavorite" (view)="viewProductDetails($event)" [list]="i"
                [isCommunityProduct]="true"></common-product-card-view>
            </ng-container>
            } @else {

            <common-product-card-view (view)="viewProductDetails($event)"
              *ngFor="let i of productAllProductListFiltered | filterBy : filterProp : filterValue" [list]="i"
              [isCommunityProduct]="true"></common-product-card-view>
            }

            } @else {
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            <div class="card-skeleton">
              <div class="image-placeholder"></div>
              <div class="content-placeholder">
                <div class="title-placeholder"></div>
                <div class="desc-placeholder"></div>
              </div>
            </div>
            }
          </div>
        </div>
      </app-my-tabs>
    </div>
  </div>
  <div class="profile-mini">
    <div class="profile-mini__body">
      <div class="level" [class.fit-height]="openShepherd">
        <div class="title-mobile">Profile</div>
        <img loading="lazy" class="img" src="../../../../../../assets/images/new/badge.png" />
        <div class="phone">
          {{ maskNumber(profileInfo?.phone) || "" }}
        </div>
        <div class="all">
          <span> {{ profileInfo?.points || 0 }} XP / {{ profileInfo?.requirePoints || 0 }} XP</span>
          <div class="diamonds" (click)="openBuyDiamonds()">
            <div class="diamonds__text">{{ diamonds }}</div>
            <img loading="lazy" class="diamonds__img" src="../../../../../../assets/images/diamond.png" />
          </div>
        </div>
        <ngb-progressbar [animated]="true" [value]="profileInfo?.progressBarValue || 0"
          [striped]="true"></ngb-progressbar>
        <div class="hexagon">{{ profileInfo?.level }}</div>
        <ul [class.open]="openList">
          <li>
            <a>
              <i class="fa-solid fa-clipboard-list"></i>
              <div class="right">
                <span class="text">Forum Posts</span>
                <span class="badge badge-warning">
                  {{ profileInfo?.forumPostsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-pen-square"></i>
              <div class="right">
                <span class="text">Suggestions</span>
                <span class="badge badge-warning">
                  {{ profileInfo?.suggestionsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-user"></i>
              <div class="right">
                <span class="text">Referrals</span>
                <span class="badge badge-warning">
                  {{ profileInfo?.referralsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-heart"></i>
              <div class="right">
                <span class="text">Favorite Products</span>
                <span class="badge badge-warning">
                  {{ profileInfo?.favorites?.length || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-shop"></i>
              <div class="right">
                <span class="text">Products sell</span>
                <span class="badge badge-warning">
                  {{ 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-shop"></i>
              <div class="right">
                <span class="text">Products Rent</span>
                <span class="badge badge-warning">
                  {{ 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-shop"></i>
              <div class="right">
                <span class="text">Products Donate</span>
                <span class="badge badge-warning">
                  {{ 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-shop"></i>
              <div class="right">
                <span class="text">Products History</span>
                <span class="badge badge-warning">
                  {{ 0 }}
                </span>
              </div>
            </a>
          </li>
        </ul>
        <div class="arrow-down" [class.active]="openList" (click)="openList = !openList">
          <i class="fa-solid fa-caret-down"></i>
        </div>
      </div>
      <div class="content">
        <div class="setting" [class.fit-height]="openList">
          <div class="profile-mini__card">
            <div class="profile-mini__card--body">
              <div class="profile-mini__card--body__title">Profile</div>
              <div class="profile-mini__card--body__desc">Your profile dashboard allows you to see all your information
                in one place for easy access.</div>
            </div>
            <div class="profile-mini__card--footer">
              <div class="d-flex" style="margin-left: -0.75rem; gap: 5px">
                <ng-container *ngFor="let item of profileInfo.certificates; let i = index">
                  <img loading="lazy" src="{{ imgUrl }}{{ item.role }}.png" alt=""
                    style="height: 2rem; border-radius: 50%" />
                </ng-container>
              </div>
              <div>
                <button class="button-2 mr-2" [routerLink]="['/community/profile', profileInfo?.referralCode]">User
                  View</button>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-mini__card" [class.fit-height]="openList">
          <div class="profile-mini__card--body">
            <div class="profile-mini__card--body__title">Roles</div>
            <div class="profile-mini__card--body__desc">Choose various roles to provide to your community and find out
              more on how you can earn.</div>
          </div>
          <div class="profile-mini__card--footer">
            <div class="images">
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Driver.jpeg" alt="" />
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Handyman.jpeg" alt="" />
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Butler.jpeg" alt="" />
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Cleaner.jpeg" alt="" />
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Teacher.jpeg" alt="" />
              <img loading="lazy" src="../../../../../../assets/images/profile-charactor/Chef.jpeg" alt="" />
              <div class="text">6 Roles</div>
            </div>
            <button class="button-2" routerLink="/roles">open</button>
          </div>
        </div>
        <div [class.fit-height]="openList" class="profile-mini__card quests-Shepherd">
          <div class="profile-mini__card--body pb-0">
            <div class="profile-mini__card--body__title">
              <div class="bar">
                Quests
                <span>Earn points</span>
              </div>
            </div>
            <ul [class.open]="openShepherd">
              <ng-container *ngFor="let item of questList">
                <li class="info-Shepherd">
                  <div class="text" (click)="item?.myFun ? item?.myFun() : ''">
                    {{ item?.description }}
                    <i *ngIf="item?.myFun" class="fa-solid fa-circle-info"></i>
                  </div>
                  <span class="badge badge-warning"
                    [ngClass]="{ green: item?.status && item?.status == 'completed' }">100</span>
                </li>
              </ng-container>

              <!-- <li>
                    <div class="text" (click)="tutorials ? sharedService.shepherd('suggestion-product') : ''">
                      @if(tutorials){
                      <i class="fa-solid fa-circle-info"></i>
                      } Submit a suggestion for a product
                    </div>
                    <span class="badge badge-warning">100</span>
                  </li> -->
              <!-- <li>
                    <div class="text" (click)="tutorials ? sharedService.shepherd('favorites-product') : ''">
                      @if(tutorials){
                      <i class="fa-solid fa-circle-info"></i>
                      } Add a product to your favorites
                    </div>
                    <span class="badge badge-warning">20</span>
                  </li> -->
              <!-- <li>
                    <div class="text" (click)="tutorials ? sharedService.shepherd('create-news') : ''">@if(tutorials){<i class="fa-solid fa-circle-info"></i>} Write an article</div>
                    <span class="badge badge-warning">20</span>
                  </li> -->
              <!-- <li>
                    <div class="text" (click)="tutorials ? sharedService.shepherd('create-forum') : ''">@if(tutorials){<i class="fa-solid fa-circle-info"></i> } Create a new forum post</div>
                    <span class="badge badge-warning">20</span>
                  </li> -->
              <!-- <li>
                    <div class="text" (click)="tutorials ? sharedService.shepherd('answer-forum') : ''">
                      @if(tutorials){
                      <i class="fa-solid fa-circle-info"></i>
                      } Answer a forum post
                    </div>
                    <span class="badge badge-warning">20</span>
                  </li> -->
            </ul>
            <div class="arrow-down" [class.active]="openShepherd" (click)="openShepherd = !openShepherd">
              <i class="fa-solid fa-caret-down"></i>
            </div>
          </div>
          <div class="profile-mini__card--footer">
            <div class="text">Accumulate enough points to reach the next level and unlock new upgrades and abilities.
            </div>
          </div>
        </div>
        <div [class.fit-height]="openShepherd || openList" class="profile-mini__card">

          <div class="not-allowed" *ngIf="(profileInfo?.level ?? 1) < 5">You have to be level 5 and above to subscribe
            or purchase tokens</div>
          <div class="profile-mini__card--body">
            <div class="profile-mini__card--body__title">Avatar</div>
            <div class="profile-mini__card--body__desc">Your avatar will have various equipment you can use to beautify
              your character or improve your shop functionality.</div>
          </div>
          <div class="profile-mini__card--footer">
            <div class="div"></div>
            <button class="button-2" (click)="openAvatarPopup()">open</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="faq-link">
    Don't know what to sell? <a routerLink="/faq">Check out our FAQ</a>
  </div>
</div>



<ng-template #SharePopup let-modal>
  <div class="modal-body referral-modal">
    <div class="add_cattt">
      <h2>Share</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img"
        (click)="modal.dismiss('Cross click')" />
    </div>


    <div class="referral-link">
      <h6>
        <span>Profile Link</span>
      </h6>
      <div
        style="display: flex; flex-direction: column; align-items: center; margin-bottom: 2rem; margin-top: -24px; word-wrap: break-word;">
        <a class="referral-title w-100 mt-2 mb-2" href="{{ refer_friend_link }}" target="_blank" style="width: 80%">
          <p class="ref_link">{{ refer_friend_link }}</p>
        </a>
        <section class="d-flex w-100 justify-content-center mt-4">
          <div class="">
            <a class="confirm_button mr-2" (click)="copyReferralLink()">
              <img loading="lazy" src="../../../../assets/images/copy-icon.svg" alt="img" />
              Copy</a>
          </div>
          <div class="">
            <a class="confirm_button" (click)="share(refer_friend_link)">
              <i class="fa fa-share"></i>
              Share</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-template>

<app-marketplace #marketplace [share]="true"></app-marketplace>